import '../styles/index.css';

export interface ChatBubbleProps {
  speaker: string;
  displayName: string;
  text: string;
  avatarUrl?: string;
  side: 'left' | 'right';
  variant: 'say' | 'think';
  showAvatar?: boolean;
}

export function ChatBubble({
  speaker,
  displayName,
  text,
  avatarUrl,
  side,
  variant,
  showAvatar = true,
}: ChatBubbleProps) {
  const containerClass = [
    'pawa-chat-container',
    'pawa-chat-item',
    side === 'left' ? 'pawa-left' : 'pawa-right',
    variant === 'think' ? 'pawa-think' : '',
  ].filter(Boolean).join(' ');

  // Get initials for avatar placeholder
  const initials = displayName
    .split(' ')
    .map(n => n[0])
    .join('')
    .slice(0, 2);

  return (
    <div
      className={containerClass}
      data-speaker={speaker}
    >
      {showAvatar && (
        <div className="pawa-chat-avatar-wrapper">
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt={displayName}
              className="pawa-chat-avatar"
            />
          ) : (
            <div className="pawa-chat-avatar-placeholder">
              {initials}
            </div>
          )}
        </div>
      )}
      <div className="pawa-chat-bubble-wrapper">
        <div className="pawa-chat-name-label">{displayName}</div>
        <div className="pawa-chat-bubble">
          <span className="pawa-chat-text">{text}</span>
        </div>
      </div>
    </div>
  );
}
